import { FC } from 'react';

import LinkCard from '@/ux-legacy/components/common/PortalFeed/Cards/LinkCard';

type LinkContentProps = {
  link: string;
  metadata: any;
};

const LinkContent: FC<LinkContentProps> = ({ link, metadata }) => {
  return (
    <a href={link} className="cursor-pointer w-full h-full flex" target="_blank" rel="noreferrer">
      <LinkCard link={link} metadata={metadata} bgColor="transparent" />
    </a>
  );
};

export default LinkContent;
